/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SearchTagList.vue?vue&type=template&id=5a431d9c&scoped=true"
import script from "./SearchTagList.vue?vue&type=script&lang=js"
export * from "./SearchTagList.vue?vue&type=script&lang=js"
import style0 from "./SearchTagList.vue?vue&type=style&index=0&id=5a431d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a431d9c",
  null
  
)

export default component.exports